import '@talentmesh/table/styles.css';
import { TypographyH2 } from '@talentmesh/ui/components/typography';
import { TeamMembersContext } from './Context/TeamMembersContext';
import useTeamMembersContextValue from './Context/useTeamMembersContextValue';
import TeamMemberTabContent from './TeamMemberTabContent';
import UIStrings from '@/Utils/UIStrings';

const TeamMembersTab = () => {
    const value = useTeamMembersContextValue();

    return (
        <TeamMembersContext.Provider value={value}>
            <div className="flex flex-col gap-6">
                <TypographyH2>{UIStrings.TeamMembers}</TypographyH2>
                <TeamMemberTabContent />
            </div>
        </TeamMembersContext.Provider>
    );
};

export default TeamMembersTab;
